// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 118) return "js/resource/js/components/login.js";
	if (chunkId === 844) return "js/resource/js/components/register.js";
	if (chunkId === 25) return "js/resource/js/components/recoverPassword.js";
	if (chunkId === 489) return "js/resource/js/components/resetPassword.js";
	if (chunkId === 35) return "js/resource/js/components/farmRegister.js";
	if (chunkId === 649) return "js/resource/js/components/layouts/dashboard.js";
	if (chunkId === 769) return "js/resource/js/components/layouts/default.js";
	if (chunkId === 690) return "js/resource/js/components/temporary.js";
	if (chunkId === 33) return "js/resource/js/components/sev-user-profile.js";
	if (chunkId === 291) return "js/resource/js/components/sev-example-profile.js";
	if (chunkId === 985) return "js/resource/js/components/sev-units.js";
	if (chunkId === 9) return "js/resource/js/components/pages/terms.js";
	if (chunkId === 994) return "js/resource/js/components/pages/not-found.js";
	// return url for filenames based on template
	return undefined;
};